import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';

import { SHIPMENT_FILTERS_STATE_KEY } from '../constants/shipment-filter-constants';
import type { ShipmentFilter } from '../constants/shipment-filter-constants';

type LocationState = {
  [SHIPMENT_FILTERS_STATE_KEY]?: ShipmentFilter[];
} | null;

/**
 * Hook to get shipment filters passed from operations cards via route state.
 * Returns filter objects that can be applied to the shipment grid.
 */
export const useOperationsCardShipmentFilters = (): ShipmentFilter[] | null => {
  const location = useLocation();

  const state = location.state as LocationState;
  const shipmentFilters = state?.[SHIPMENT_FILTERS_STATE_KEY];
  const hasFilters = Array.isArray(shipmentFilters) && shipmentFilters.length > 0;

  // Serialize filter data so the memo only recomputes when actual values change,
  // not when location.state provides a new object reference on each navigation.
  const filtersKey = hasFilters ? JSON.stringify(shipmentFilters) : null;

  return useMemo(() => {
    if (!filtersKey) {
      return null;
    }

    return JSON.parse(filtersKey) as ShipmentFilter[];
  }, [filtersKey]);
};
